import { render } from "./SpotsSearch.vue?vue&type=template&id=5fd4606c&scoped=true"
import script from "./SpotsSearch.vue?vue&type=script&lang=js"
export * from "./SpotsSearch.vue?vue&type=script&lang=js"

import "@/assets/css/table-resp.css?vue&type=style&index=0&id=5fd4606c&scoped=true&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fd4606c"]])

export default __exports__